import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';

import WarningIcon from '@material-ui/icons/ErrorOutline';

import Button from '../../shared/Button';
import Input from '../../shared/Input';

import '../../../styles/shared/form.scss';
import DeleteIcon from '@material-ui/icons/CloseOutlined';
import Dropzone from '../../shared/dropzone';

const NoteForm = (props) => {
  const {
    mode = 'create',
    initialValues,
    onSubmit = () => {},
    loading,
    onClose,
    withoutText,
    count = false,
    tenantColor,
    onDeleteImage,
  } = props;

  const [files, setFiles] = useState([]);

  const onUpload = (newFiles) => {
    setFiles([
      ...files,
      ...newFiles.filter((file) => !files.map((f) => f.name).includes(file.name)),
    ]);
  };

  const onRemove = (fileName) => {
    setFiles([...files].filter((item) => item.name !== fileName));
  };

  const validate = (values) => {
    const errors = {};

    if (!values.note) {
      errors.note = 'Required';
    }

    return errors;
  };

  return (
    <div className='form__container'>
      <Form
        onSubmit={(formObj) => onSubmit(formObj, files)}
        validate={validate}
        subscription={{ pristine: true, invalid: true }}
        initialValues={initialValues}
      >
        {
          ({ handleSubmit, submitting, invalid, pristine }) => (
            <form onSubmit={handleSubmit} className='form__body'>
              <div className='form__subtitle'>
                {mode === 'update' ? 'Edit Note' : 'Add Note'}
              </div>

              {!withoutText && (
                <div className='form__warning-text m-b-lg'>
                  <WarningIcon />
                  <span className='m-l-sm'>{count ? 'Count' : 'Case'} notes are shared with all users</span>
                </div>
              )}

              <div className='m-b-lg'>
                <div className='field__title'>Note</div>
                <Field name='note'>
                  {({ input, meta }) => (
                    <Input
                      name={input.name}
                      value={input.value}
                      type='textarea'
                      onChange={input.onChange}
                    />
                  )}
                </Field>
              </div>

              <div className='m-b-lg'>
                <div className='field__title'>Supporting Images</div>

                {initialValues && !!initialValues?.attachments?.length && (
                  <div className='d-flex m-t-md m-b-lg'>
                    {initialValues?.attachments?.map((item) => (
                      <div
                        key={`${item.id}_${item.fileName}`}
                        style={{ width: 80, height: 80, borderRadius: 8, position: 'relative' }}
                        className='m-r-lg pointer'
                        onClick={() => window.open(item.downloadUrl, '_blank')}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: -12,
                            right: -12,
                            backgroundColor: '#ffffff',
                            borderRadius: '50%',
                            height: '24px',
                            width: '24px',
                            border: '1px solid #eeeeee',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteImage(item);
                          }}
                        >
                          <DeleteIcon color='error' />
                        </div>
                        <img
                          src={item.downloadUrl}
                          alt='preference-preview'
                          style={{ width: 80, height: 80, borderRadius: 8 }}
                        />
                      </div>
                    ))}
                  </div>
                )}

                <Dropzone
                  files={files}
                  withoutProgress
                  onUpload={onUpload}
                  onRemove={onRemove}
                  tenantColor={tenantColor}
                  text='Drag and drop images here or click to upload'
                  type='image'
                />
              </div>

              <div className='form__actions'>
                <Button
                  type='submit'
                  text={mode === 'update' ? 'Save Changes' : 'Add Note'}
                  disabled={invalid || loading}
                  loading={loading}
                  onClick={handleSubmit}
                />
                <Button
                  type='cancel'
                  onClick={onClose}
                />
              </div>
            </form>
          )}
      </Form>
    </div>
  );
};

export default NoteForm;
